export default "__VITE_ASSET__DTePDf9w__"